// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper--1C9un","content":"content--3UrU2","buttons":"buttons--1XtDq"};